export const HeaderNames = { ContentDisposition: 'content-disposition' };
